// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9617751c","455":"61b822db"}[chunkId] + ".chunk.js";
};